<template>
  <div class="member-area-tab-color-config-component">
    <div class="my-3">
      Placeholders
    </div>
    <small class="text-secondary d-block mb-6">
      Defina imagens padrão que possam ser utilizadas caso algum conteúdo vá ao
      ar sem configuração de imagem. Assim, você garante que sua área de membros
      nunca passe a impressão de estar incompleta.
    </small>

    <div class="mb-5 fs-14">
      Placeholder capa horizontal
    </div>

    <div class="card-box p-9">
      <input-image
        v-model="form.placeholder_cover"
        id="horizontal-cover-image"
        title="Capa horizontal"
        description="Caso não seja adicionada uma imagem de capa nos módulos, por padrão esta imagem irá no lugar."
        dimensions="2160x740px"
      />
      <horizontal-cover-mockup
        :image="form.placeholder_cover"
        class="d-none d-lg-block"
      />
    </div>
    <hr />

    <div class="mb-5 fs-14">
      Placeholder cartaz vertical
    </div>

    <div class="card-box p-9">
      <input-image
        v-model="form.placeholder_module"
        id="vertical-cover-image"
        title="Cartaz vertical"
        description="Caso não seja adicionada uma imagem de cartaz nos módulos, por padrão esta imagem irá no lugar."
        dimensions="440x632px"
      />
      <vertical-poster-mockup
        :image="form.placeholder_module"
        class="d-none d-lg-block"
      />
    </div>
    <hr />

    <div class="mb-5 fs-14">
      Placeholder cartaz horizontal
    </div>

    <div class="card-box p-9">
      <input-image
        v-model="form.placeholder_lesson"
        id="horizontal-poster-image"
        title="Cartaz das aulas"
        description="Caso não seja adicionada uma imagem de cartaz nas aulas, por padrão esta imagem irá no lugar."
        dimensions="686x414px"
      />
      <horizontal-poster-mockup
        :image="form.placeholder_lesson"
        class="d-none d-lg-block"
      />
    </div>

    <hr />

    <div class="mb-5 fs-14">
      Placeholder capa versão mobile
    </div>

    <div class="card-box p-9">
      <input-image
        v-model="form.placeholder_cover_mobile"
        id="horizontal-poster-image"
        title="Cartaz horizontal"
        description="Caso não seja adicionada uma imagem de cartaz nas aulas, por padrão esta imagem irá no lugar."
        dimensions="375x495px"
      />
      <vertical-cover-mobile-mockup
        :image="form.placeholder_cover_mobile"
        class="d-none d-lg-block"
      />
    </div>
  </div>
</template>
<script>
import HorizontalCoverMockup from "@/components/product/member-area/setup/HorizontalCoverMockup.vue";
import HorizontalPosterMockup from "@/components/product/member-area/setup/HorizontalPosterMockup.vue";
import VerticalCoverMobileMockup from "@/components/product/member-area/setup/VerticalCoverMobileMockup.vue";
import VerticalPosterMockup from "@/components/product/member-area/setup/VerticalPosterMockup.vue";
export default {
  components: {
    VerticalCoverMobileMockup,
    HorizontalPosterMockup,
    HorizontalCoverMockup,
    VerticalPosterMockup
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
<style lang="scss">
.member-area-tab-color-config-component {
  .card-box {
    height: fit-content;
    width: fit-content;
    display: flex;
    gap: 80px;
  }
  hr {
    margin: 24px 0;
  }
}
</style>
